<template>
<div class="gj-table-tab">
  <!-- 固定的tab，只显示和隐藏 -->
  <div class="gj-group-tabs-fixed">
    <template v-for="(item, index) in groupTabs">
      <div v-if="item"
        :key="item.name"
        :class="`gj-group-tab gj-group-${item.name}`"
        v-show="fixedGroupVisible[index]"
        :style="`
          background: #${COLORS[index]};
          left: ${fixedLeftWidth}px;
        `"
      >
        <slot :name="item.slot"></slot>
      </div>
    </template>
  </div>

  <!-- 移动的tab，跟随 scroll 移动，到达边际消失 -->
  <div class="gj-group-tabs">
    <div :style="`transform: translateX(${groupTabsX}px)`"
    >
      <template v-for="(item, index) in groupTabs">
        <div v-if="item"
          :key="item.name"
          :class="`gj-group-tab gj-group-${item.name}`"
          v-show="item.show"
          :style="`
            background: #${COLORS[index]};
            left: ${item.left}px;
          `"
        >
          <slot :name="item.slot"></slot>
        </div>
      </template>
    </div>
  </div>
</div>
</template>

<script>
import _ from 'lodash'
import { COLORS } from './index.js'

let _scrollLeft = 0;

export default {
  name: 'GjTableTab',
  props: {
    columns:{
      type:Array,
      default:()=>[],
      require:true
    },
    gjTable: {
      type: Object,
      default: () => {}
    },
    slotGroup: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      COLORS,
      groupColumnMap: {},
      groupTabs: [],
      groupTabsX: 0,
      fixedLeftWidth: 555,
      fixedGroupVisible: [],
    }
  },
  watch: {
    columns: {
      handler(newVal){
        this.processColumn(newVal)
      },
      immediate:true
    },
    gjTable: {
      handler() {
        this.processGroupTabs();
      },
    }
  },
  methods: {
    processColumn(columns=[]) {
      // 处理列
      const groupColumnMap = {};
      const groupColumns = columns.filter(e => e.group && e.field);
      groupColumns.forEach(c => {
        const { group } = c;
        const a = groupColumnMap[group.id] || []
        a.push(c);
        groupColumnMap[group.id] = a;
      })
      this.groupColumnMap = groupColumnMap;
       
      // 给列增加高亮样式
      Object.keys(groupColumnMap).forEach((k, i) => {
        columns.forEach(e => {
          if (e.group?.id === k) {
            e.headerClassName = `gj-group-header gj-group-header-${k} gj-group-header--${COLORS[i]}`;
          }
        })
      })
    },
      /** 处理分组的tabs位置 */
    processGroupTabs: _.debounce(function () {
      if (!this.gjTable) return;
      const { tableColumn } = this.gjTable.getTableColumn();
      const _widths = []
      Object.values(this.groupColumnMap).forEach((a) => {
        const width = a.map(i => {
          const col = this.gjTable.getColumnByField(i.id) || 
            this.gjTable.getColumnByField(`slot:${i.id}`);
          return col?.renderWidth || 0
        }).reduce((a,b)=> a+b);
        _widths.push(width)
      });

      this.fixedLeftWidth = tableColumn.filter(v => v.fixed === 'left').map(v => v.renderWidth).reduce((a,b) => a+b, 0);
      this.groupTabs = Object.keys(this.groupColumnMap).map((k, index) => {
        const left = document.querySelector(`.gj-group-header-${k}`)?.offsetLeft;
        return {
          left,
          show: !!left,
          width: _widths[index],
          name: k,
          slot: this.slotGroup.find(s => s.includes(k)),
        }
      })
      if (_scrollLeft) this.adjustScroll(_scrollLeft)
    }, 100),

    /** 数据变动，比如 col 位置调整 */
    handleChange() {
      this.processGroupTabs();
      this.$nextTick(() => {
        this.adjustScroll(_scrollLeft);
      });
    },

    /** 表格滚动 */
    handleScroll(e) {
      const { scrollLeft } = e;
      this.groupTabsX = -scrollLeft;
      _scrollLeft = scrollLeft
      this.adjustScroll(scrollLeft)
    },

    /** 矫正 tab 位置 */
    adjustScroll(scrollLeft) {
       this.groupTabs.forEach((item, index) => {
        const offsetLeft = item.left - this.fixedLeftWidth
        item.show = offsetLeft >= scrollLeft;
        this.fixedGroupVisible[index] = !item.show && scrollLeft < offsetLeft + item.width;
      });
    }
  }
}
</script>

<style lang="scss">
.gj-table-tab {
  position: relative;
}
.vxe-table--fixed-left-wrapper,
.vxe-table--fixed-right-wrapper {
  z-index: 20!important;
  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    z-index: 20;
    width: 100%;
    height: 1px;
    background-color: #E4E5E6;
  }
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    z-index: 20;
    width: 1px;
    height: 100%;
    background-color: #E4E5E6;
  }
}
.vxe-table--fixed-right-wrapper {
  &::before {
    left: auto;
    right: 0
  }
}
.gj-group-header {
  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    z-index: 19;
    width: 100%;
    height: 1px;
    background-color: transparent;
  }
}
$color: '1F6EEF', 'FF7D00', 'F53F3F', '0FC6C2', 'F7BA1D', '722ED1', 'FADB1B', '9FDB1C', 'D91BD9', 'F5319D'; 
@each $c in $color {
  .gj-group-header--#{$c} {
    &::after {
      background-color: unquote('##{$c}');
    }
  }
}
.gj-group-tabs {
  overflow: hidden;
  height: 20px;
  font-size: 12px;
  color: white;
  display: flex;
  &-fixed {
    position: absolute;
    font-size: 12px;
    color: white;
    display: flex;
    left: 0;
    top: 0;
    width: 100%;
    height: 20px;
  }
}
.gj-group-tab {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 1px 10px 1px 8px;
  .gj-help--icon .gj-icon {
    color: white!important;
  }
}
</style>